import AsyncState, { createAsyncStateReducer } from "react-async-stateful";
import * as ReduxUtils from "../../lib/util/ReduxUtils";
import * as StorageUtils from "../../lib/util/StorageUtils";
import * as UserActions from "./User.action";
import { OVERRIDE_FLEET_KEY, USER_OBJECT_KEY } from "../../StorageKeys";
import { User } from "../../lib/types/UserTypes";
import { MultiFactorDetails } from "../../lib/types/AuthTypes";

export interface UserReducerState {
	user: User | null | undefined;
	loginRejectionCount: number;
	login: AsyncState<void>;
	signOut: AsyncState<void>;
	refreshUserObject: AsyncState<void>;
	multiFactorDetails: MultiFactorDetails | null;
}

const initialState: UserReducerState = {
	user: {} as any,
	loginRejectionCount: 0,
	login: AsyncState.create(),
	signOut: AsyncState.create(),
	refreshUserObject: AsyncState.create(),
	multiFactorDetails: null,
};

export default ReduxUtils.composeReducer(
	initialState,
	(initialState) => ({
		...initialState,
		user: {
			...(StorageUtils.get(USER_OBJECT_KEY) || {}),
			fleetIdOverride: StorageUtils.get(OVERRIDE_FLEET_KEY) || null,
		} as any,
	}),
	[
		createAsyncStateReducer<UserReducerState>({
			login: UserActions.login.type,
			signOut: UserActions.signOut.type,
			refreshUserObject: UserActions.refreshUserObject.type,
		}),

		ReduxUtils.createReducerMap({
			[UserActions.updateUserObject.type]: (state, action) =>
				action.payload
					? {
							...state,
							user: { ...state.user, ...(action.payload || {}) },
					  }
					: state,

			[UserActions.addLoginRejection.type]: (state, action) => ({
				...state,
				loginRejectionCount: state.loginRejectionCount + 1,
			}),

			[UserActions.setMultiFactorDetails.type]: (state, action) => ({
				...state,
				multiFactorDetails: action.payload,
			}),
		}),
	],
);
